/**
 * Get percentage as discount
 * @param {number} current
 * @param {number} orig
 */
export const toPercentage = (current, orig) => Math.floor((((orig - current) / orig) * 100).toFixed(2));/**

* Get percentage as remaining
* @param {number} current
* @param {number} orig
*/
export const toPercentageInverse = (current, orig) => 100 - Math.floor((((orig - current) / orig) * 100).toFixed(2));

/**
 * Check if is number
 * @param {string} num
 */
export const isNumeric = (num) => !isNaN(num);

/**
 * Change number to price
 * @param {number} num
 */
export const toPrice = (num) => num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
